import React from 'react';
import { useTranslation } from 'react-i18next';
import { FlexibleArrow } from '../../../atoms/FlexibleArrow/FlexibleArrow';
import { ProCol } from '../../../atoms/Grid/Col';
import { ProRow } from '../../../atoms/Grid/Row';
import { ProIcon } from '../../../atoms/Icons/Icon';
import { ProIconTypeData } from '../../../atoms/Icons/IconData';
import { ProMenuCard } from '../../../atoms/MenuCard/MenuCard';
import { ApplicationElementType, getBaseBCItemForType } from '../../../components/DetailWindow/breadCrump.helpers';
import { ProPage } from '../../../components/Page/Page';
import { MenuItemType } from '../../../constants/types';
import { RoutingHistorySections } from '../../../hooks/useRouting';
import { proLinkStructure } from '../../../modules/Menu/Navigate';
import { ProIntent } from '../../../utils/enums';

export const TeamCeremoniesPage = () => {
    const { t } = useTranslation();

    const agileAMenu: MenuItemType[] = [
        {
            icon: ProIconTypeData.Ready,
            link: '/app/teams/ceremonies/grooming',
            name: 'Backlog Grooming',
            section: RoutingHistorySections.teamManagement,
            subName: 'Scoping',
            iconSection: (
                <div className="CeremoniesCard__iconSection">
                    <FlexibleArrow style={{ left: '-36px' }} length={96} />
                    <ProIcon icon={ProIconTypeData.NotReady} intent={ProIntent.Secondary} />
                    <FlexibleArrow length={116} style={{ left: '104px' }} />
                    <ProIcon icon={ProIconTypeData.Ready} intent={ProIntent.Secondary} />
                </div>
            ),
            bar: 'horisontal',
        },
        {
            icon: ProIconTypeData.Scheduled,
            link: '/app/teams/ceremonies/planning',
            name: 'Sprint Planning',
            section: RoutingHistorySections.teamManagement,
            subName: 'Scheduling',
            iconSection: (
                <>
                    <FlexibleArrow length={246} style={{ left: '-106px' }} />
                    <ProIcon icon={ProIconTypeData.Scheduled} intent={ProIntent.Secondary} />
                </>
            ),
            bar: 'horisontal',
        },
        {
            icon: ProIconTypeData.Review,
            link: '/app/teams/ceremonies/daily',
            name: 'Daily Standup',
            section: RoutingHistorySections.teamManagement,
            subName: 'Processing',
            iconSection: (
                <>
                    <FlexibleArrow style={{ left: '-196px' }} length={256} />
                    <ProIcon icon={ProIconTypeData.UnderDev} intent={ProIntent.Secondary} />
                    <FlexibleArrow style={{ left: '102px' }} length={122} />
                    <ProIcon icon={ProIconTypeData.Review} intent={ProIntent.Secondary} />
                </>
            ),
            bar: 'horisontal',
        },
        {
            icon: ProIconTypeData.Finnished,
            link: '/app/teams/ceremonies/review',
            name: 'Sprint Review',
            section: RoutingHistorySections.teamManagement,
            subName: 'Acceptance',
            iconSection: (
                <>
                    <FlexibleArrow style={{ left: '-109px' }} length={256} />
                    <ProIcon icon={ProIconTypeData.Finnished} intent={ProIntent.Secondary} />
                </>
            ),
            bar: 'horisontal',
        },
    ];

    const managedMenu: MenuItemType[] = [
        {
            icon: ProIconTypeData.Scheduled,
            link: proLinkStructure.teamManagement.ceremonies.management.link,
            name: 'Project Management Meeting',
            section: RoutingHistorySections.teamManagement,
            iconSection: (
                <>
                    FORECAST
                    <FlexibleArrow length={186} relative />
                    PLAN
                </>
            ),
            bar: 'horisontal',
        },
        {
            icon: ProIconTypeData.Review,
            link: proLinkStructure.teamManagement.ceremonies.steering.link,
            name: 'Steering Committee Meeting',
            section: RoutingHistorySections.teamManagement,
            iconSection: (
                <>
                    PLAN
                    <FlexibleArrow length={206} relative />
                    BASELINE
                </>
            ),
            bar: 'horisontal',
        },
    ];

    return (
        <ProPage
            breadCrump={getBaseBCItemForType([ApplicationElementType.TeamManagement], t)}
            name={t('navigation.teamMan.ceremonies')}
        >
            <div className="Ceremonies">
                <ProRow>
                    <ProCol span={12} className="Ceremonies__firstRow">
                        <h2>Agile processes</h2>
                    </ProCol>
                </ProRow>
                <ProRow className="Ceremonies__spaceRow">
                    <ProIcon
                        icon={ProIconTypeData.Funnel}
                        intent={ProIntent.Secondary}
                        className="Ceremonies__firstIcon"
                        customSize="26px"
                    />

                    {agileAMenu.map((cur) => (
                        <ProCol span={3} className="ProCol--notHidden InlineCeremoniesRow" key={cur.name}>
                            <ProMenuCard item={cur} className="InlineCeremoniesCard" />
                        </ProCol>
                    ))}
                </ProRow>
                <ProRow>
                    <ProCol span={12}>
                        <h2>Managed processes</h2>
                    </ProCol>
                </ProRow>
                <ProRow className="Ceremonies__managedRow InlineCeremoniesRow">
                    {managedMenu.map((cur) => (
                        <ProCol span={4} className="ProCol--notHidden" key={cur.name}>
                            <ProMenuCard item={cur} />
                        </ProCol>
                    ))}
                </ProRow>
            </div>
        </ProPage>
    );
};
